export default __webpack_public_path__ + "static/media/fb36ebe7da0cddfa040013f1b76794671599782682008.1fbefda2.webp";